import { useState } from 'react';

const faqs = [
  {
    q: '51吃瓜在线的视频都是免费观看的吗？',
    a: '是的，51吃瓜在线所有视频内容完全免费。无需注册登录即可在线观看和在线播放，我们通过广告收入维持平台运营，致力于为广大瓜友提供最便捷的吃瓜体验。',
  },
  {
    q: '视频更新频率怎么样？每天有多少新内容？',
    a: '我们保持 7×24 小时不间断更新，日均上线 200+ 条新鲜吃瓜视频。编辑团队实时追踪娱乐圈、网红圈、社会热点等多个维度，确保你随时打开都有新瓜可吃。',
  },
  {
    q: '手机上看视频流畅吗？支持哪些设备？',
    a: '51吃瓜在线全面适配移动端，支持 iOS 和 Android 系统。采用智能 CDN 加速技术，无论 4G 还是 Wi-Fi 环境下都能流畅播放高清视频。我们也提供独立 APP 下载，体验更佳。',
  },
  {
    q: '视频内容的来源可靠吗？会不会有虚假信息？',
    a: '我们设有专业审核团队，所有视频内容均经过多重核实。对于爆料类内容会标注"网友投稿"标签，鼓励理性吃瓜。如发现不实信息，欢迎通过投稿渠道反馈，我们将第一时间处理。',
  },
  {
    q: '如何给我们投稿爆料？投稿有什么要求？',
    a: '你可以通过首页的"投稿爆料"入口发送邮件或添加微信。投稿内容需真实可靠并提供基本佐证，我们会对爆料人信息严格保密。一经采用将署名发布并给予奖励。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold mb-4">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            吃瓜常见疑问
          </h2>
          <p className="text-foreground-500 text-sm">关于51吃瓜在线，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/70 transition-colors"
              >
                <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 text-sm transition-transform duration-300 ${openIndex === i ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}